export default (axios) => ({
  signIn: async ({username, password} = {}) => {
    return await axios.post(`login`, {
      username,
      password
    })
  },
})
